import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { A2zLibModule, AngularMaterialModule, LoadingInterceptor, LoadingModule } from '@school/a2z-lib';
import { ViewsModule } from './views/views.module';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
import { environment } from '../environments/environment';

import { FormsComponent} from '../../../maven-forms/src/app/views/mavenform/form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon'; // <-- Needed for <mat-icon>

import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  // suppressScrollX: true,
  wheelSpeed: 0.5,
  swipeEasing: true,
  minScrollbarLength: 40,
  maxScrollbarLength: 300
};

@NgModule({
  declarations: [AppComponent,FormsComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    A2zLibModule.configureEnvironment(environment),
    AngularMaterialModule,
    HttpClientModule,
    InlineSVGModule.forRoot(),
    ViewsModule,
    LoadingModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
  ],
  exports: [
    AngularMaterialModule,
    InlineSVGModule,
    AppRoutingModule
  ],
  providers: [
    { provide: 'AppEnvironment', useValue: environment },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },{
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
